/* --------------------------------------------------------------------------------------
   scan.controller.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export default class scanCtrl {
  /*@ngInject*/
  constructor (commonService, scanService, dataService, jobStatusService, appService, $state, $scope) {
    this.commonService = commonService
    this.scanService = scanService
    this.dataService = dataService
    this.jobStatusService = jobStatusService
    this.appService = appService
    this.$state = $state
    this.$scope = $scope
  }

  $onInit () {
    //this.commonService.setNavyBackground()
    this.disable = false
  }

  scan () {
    this.closeOrExit = false
    this.processing = true
    this.scanService.scan()
      .then(jobId => this.jobStatusService.getScanFinishedStatus(jobId))
      .then(() => this.changeState())
      .catch(error => {
        this.appService.handleError(error)
          .then(result => {this.error = result})
      })
  }

  changeState() {
    this.processing = false
    if (!this.closeOrExit) {
      this.$state.go('main')
    }
  }

  closegrading () {
    this.closeOrExit = true
    this.$state.go('main')
  }

  exitgrading() {
    this.closeOrExit = true
    this.$state.go('users')
  }
  errorClosed() {
    return this.appService.errorClosed(this.error)
  }
}



// WEBPACK FOOTER //
// ./src/app/gradeTests/components/scan.controller.js